import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20_mobile px-4" }
const _hoisted_3 = { class: "widget px-7 py-7" }
const _hoisted_4 = { class: "form-field-floating reactive active my-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-red"
}
const _hoisted_6 = { class: "my-4" }
const _hoisted_7 = {
  key: 1,
  class: "text-red"
}
const _hoisted_8 = {
  key: 2,
  class: "text-red"
}
const _hoisted_9 = { class: "flex gap-2" }

import { inject, onMounted, reactive, ref } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';
    // @ts-expect-error raison: lib externe mal typée
    import Vue3TagsInput from 'vue3-tags-input';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketAttributsFormView',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        guid: "",
        nom: "", 
        valeurs: [],
    });
    const errors = reactive({
        nom: "",
        valeurs: "",
    });

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        if (form_datas?.attribut) {
            const item = form_datas.attribut as any;
            formData.guid = item.guid;
            formData.nom = item.nom;
            formData.valeurs = item.valeurs;
        }
    });

    function validate() {
        let isValid = true;

        errors.nom = '';
        if (!formData.nom) {
            errors.nom ="Le nom est requis";
            isValid = false;
        }

        errors.valeurs = '';
        if (!formData.valeurs || formData.valeurs.length === 0) {
            errors.valeurs ="Au moins une énumération est requise";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                guid: formData.guid,
                nom: formData.nom,
                valeurs: formData.valeurs,
            };

            await axios.post(`/backoffice/market-attributs/save`, formToUpload);
            router.push('/app/market/market-attributs/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }
    function handleChangeTag(newTags: any) {
        formData.valeurs = newTags;
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
          _createTextVNode("Attributs Market / Edition "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.nom) = $event)),
            name: "nom",
            id: "nom",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.nom]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("label", { for: "nom" }, [
            _createTextVNode("Libellé "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['nom'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(errors['nom']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "nom" }, [
            _createTextVNode("Valeurs "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          _createVNode(_unref(Vue3TagsInput), {
            placeholder: "Saisir les valeurs",
            onOnTagsChanged: handleChangeTag,
            tags: formData.valeurs
          }, null, 8, ["tags"])
        ]),
        (!!errors['valeurs'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(errors['valeurs']), 1))
          : _createCommentVNode("", true),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-text-xs text-grey-500 mb-5" }, [
          _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
          _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_custom_button, {
            id: "btn-submit",
            type: "button",
            classesList: 'btn lg w-100',
            loading: loading.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Enregistrer", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ])
  ]))
}
}

})